module.exports = __webpack_public_path__ + "static/media/zilterWhite1.95b3857b.png";